import PageTitle from "../PageTitle";
const PageHeader = ({ title, actions }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <PageTitle title={title} />
      <div style={{ marginBottom: 30, display: "flex", gap: "10px" }}>
        {actions}
      </div>
    </div>
  );
};

export default PageHeader;
